import type { AxiosInstance, AxiosResponse } from 'axios';
import { govApiLog } from '@gov-nx/core/app';
import type { OsobyKomunikacniUdajeDto } from '../generated';
import type { RequestData } from '../types/queryTypes';

export const robCommunicationQuery = async (
	axiosInstance: AxiosInstance
): Promise<OsobyKomunikacniUdajeDto> => {
	govApiLog('/api/v1/fyzickeosoby/komunikace');
	const { data } = await axiosInstance.get('/api/v1/fyzickeosoby/komunikace');
	return data;
};

export const verificationFinishQuery = <
	Params,
	Body extends {
		kod: string;
		hodnota: string;
		typ: 'EMAIL' | 'TELEFON';
		zdroj?: 'ROB' | 'ROS';
		ico?: number;
	},
>(
	axiosInstance: AxiosInstance,
	{ body }: RequestData<Params, Body>
): Promise<AxiosResponse<void>> => {
	govApiLog('/api/v1/komunikacniudaje/dokoncit-overeni');
	return axiosInstance.post('/api/v1/komunikacniudaje/dokoncit-overeni', body);
};

export const verificationQuery = async <
	Params,
	Body extends {
		hodnota: string;
		typ: 'EMAIL' | 'TELEFON';
		zdroj?: 'ROB' | 'ROS';
		ico?: number;
	},
>(
	axiosInstance: AxiosInstance,
	{ body }: RequestData<Params, Body>
): Promise<void> => {
	govApiLog('/api/v1/komunikacniudaje/overit');
	return axiosInstance.post('/api/v1/komunikacniudaje/overit', body);
};
